import { useMemo } from 'react';
import { usePopper as useCorePopper } from 'react-popper';
import { useZIndex } from '../components/ZIndexProvider/ZIndexProvider';
import { isElement } from '../helpers/dom';
export const placements = ['top', 'top-start', 'top-end', 'bottom', 'bottom-start', 'bottom-end', 'right', 'right-start', 'right-end', 'left', 'left-start', 'left-end', 'auto', 'auto-start', 'auto-end'];

function extractElement(elementOrRef) {
  if (!elementOrRef) {
    return null;
  }

  if (isElement(elementOrRef)) {
    return elementOrRef;
  }

  return elementOrRef.current;
}

export function usePopper(referenceElement, popperElement, options) {
  const zIndex = useZIndex();
  const {
    styles: popperStyles,
    update,
    attributes
  } = useCorePopper(extractElement(referenceElement), extractElement(popperElement), options);
  const styles = useMemo(() => Object.assign({}, popperStyles, {
    popper: Object.assign({}, popperStyles.popper, {
      zIndex
    })
  }), [popperStyles, zIndex]);
  return {
    styles,
    update,
    attributes
  };
} // Modifiers

const offset = {
  name: 'offset',
  options: {
    offset: [0, 2]
  }
};
const matchReferenceWidth = {
  name: 'matchReferenceWidth',
  enabled: true,
  phase: 'beforeWrite',
  requires: ['computeStyles'],
  fn: ({
    state
  }) => {
    state.styles.popper.width = `${state.rects.reference.width}px`;
  }
};
export const modifiers = {
  offset,
  matchReferenceWidth
};